import { render, staticRenderFns } from "./RsaSchedaOspiteRefertiComponent.vue?vue&type=template&id=3dbb39c1&scoped=true"
import script from "./RsaSchedaOspiteRefertiComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaOspiteRefertiComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaOspiteRefertiComponent.vue?vue&type=style&index=0&id=3dbb39c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb39c1",
  null
  
)

export default component.exports